import { createReducer, on } from '@ngrx/store';
import { setPanelFilters } from '../actions/statements.actions';
import { StatementsState } from '../states/statements.state';

export const initialState: StatementsState = {
  panelFilters: undefined,
};

export const StatementReducers = createReducer(
  initialState,
  on(setPanelFilters, (state, { panelFilters }) => {
    return { ...state, panelFilters };
  })
);
